import type { ChatSurfaceView } from "../store/agent-chat-slice"

export type BodySurface = "artifacts" | "workflows" | "chat"

export function resolveBodySurface(surfaceView: ChatSurfaceView, isWorkflowsEnabled: boolean): BodySurface {
  if (surfaceView === "artifacts") return "artifacts"
  if (surfaceView === "workflows" && isWorkflowsEnabled) return "workflows"
  return "chat"
}
